import { render } from "./MarketStats.vue?vue&type=template&id=246ee9c8"
import script from "./MarketStats.vue?vue&type=script&lang=js"
export * from "./MarketStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__